var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "26px",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BP-My-BP-details",
    transform: "translate(-198.000000, -505.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favourites-card",
    transform: "translate(159.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2-copy",
    transform: "translate(20.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-icon",
    transform: "translate(20.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,8.0667789 L23.7179487,8.0667789 L23.7179487,5.58469308 C23.7179487,4.90025792 23.1429487,4.34365018 22.4358974,4.34365018 L14.1025641,4.34365018 C13.9525641,4.34365018 13.8076923,4.29276742 13.6923077,4.20030972 L10.024359,1.24104291 L2.56410256,1.24104291 C1.85705128,1.24104291 1.28205128,1.79765065 1.28205128,2.48208582 L1.28205128,6.82573599 L25,6.82573599 L25,8.0667789 L1.28205128,8.0667789 L0,8.0667789 L0,2.48208582 C0,1.11321549 1.15,0 2.56410256,0 L10.2564103,0 C10.4064103,0 10.5512821,0.0508827592 10.6666667,0.143340456 L14.3346154,3.10260727 L22.4358974,3.10260727 C23.85,3.10260727 25,4.21582276 25,5.58469308 L25,8.0667789 Z",
    id: "Page-1",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#0C1229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.81138657 C0,6.70499135 0.898338318,5.80808081 2.00732994,5.80808081 L24.9926701,5.80808081 C26.1012878,5.80808081 27,6.69517754 27,7.81138657 L27,22.1970309 C27,23.3034262 26.1016617,24.2003367 24.9926701,24.2003367 L2.00732994,24.2003367 C0.898712226,24.2003367 0,23.31324 0,22.1970309 L0,7.81138657 Z",
    id: "Rectangle-path",
    stroke: "#0C1229",
    fill: "#DFE4F6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder .71d7f2db99ecffadd177b930c8d0ad46.svg";
export { ForwardRef as ReactComponent };